import React from "react";
import PageHero from "../components/PageHero";
import SectionHead from "../components/SectionHead";
import SolutionCardGrid from "../components/SolutionCardGrid";
import SolutionsList from "../components/SolutionsList";
import CtaBanner from "../components/CtaBanner";

function Solutions() {
  return (
    <>
      <PageHero
        eyebrow="Solutions"
        title="Built around real HR friction"
        subtitle="Every module in MPeoples HRMS maps to a specific attendance or HR problem — here is what it replaces."
      />

      <section className="section">
        <div className="container">
          <SectionHead eyebrow="By workflow" title="Choose a solution" center />
          <SolutionCardGrid />
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <SectionHead eyebrow="Problem → solution" title="What MPeoples HRMS replaces" />
          <SolutionsList />
        </div>
      </section>

      <CtaBanner />
    </>
  );
}

export default Solutions;
